import { render, staticRenderFns } from "./ViaView.vue?vue&type=template&id=03754d68&scoped=true&"
import script from "./ViaView.vue?vue&type=script&lang=js&"
export * from "./ViaView.vue?vue&type=script&lang=js&"
import style0 from "./ViaView.vue?vue&type=style&index=0&id=03754d68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03754d68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
